import React, { useEffect, useState } from "react";
import { Button, Carousel, Col, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProductDefaultImage from "@assets/images/product-default.png";
import ProductCountdown from "@components/ProductDetail/components/ProductCountdown";
import PlaceBidForm from "@components/ProductDetail/components/PlaceBidForm";
import PlaceBid from "@components/ProductDetail/components/PlaceBid";
import CurrentBid from "@components/ProductDetail/components/CurrentBid";
import UpcomingBid from "@components/ProductDetail/components/UpcomingBid";
import FinishedBid from "@components/ProductDetail/components/FinishedBid";
import BitelModal from "@components/Modal";
import { useViewWinner } from "@dataLayer/user";
import { PATHS } from "@config/constants";
import "./index.scss";
import PotentialWinner from "@components/PotentialWinner";
import { currentDate } from "@utils/utils";
import GiftIcon from "@components/svg/GiftIcon";
import GiftModal from "@components/Modal/GiftModal";

const { Title, Paragraph } = Typography;

const ProductDetail = ({
  product,
  showForm,
  isUpcoming,
  isHistory,
  isHistoryOverview,
  isResultOverview,
  isWinner,
  isNoOneWinner,
  isLogin,
  isPotentialWinner,
}) => {
  const { t } = useTranslation();
  const { data, error, isLoading, mutate } = useViewWinner();
  const isBidPage =
    window.location.pathname === PATHS.BID_PAGE ||
    window.location.pathname === PATHS.BID2_PAGE;

  const productImage = product?.product_image?.split(",");

  const handleClickViewWinner = () => {
    mutate(product);
  };

  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width <= 575;

  const deadline = product?.end_time || 0;
  const TWO_DAY_INTERVAL = 2 * 24 * 3600 * 1000;
  const deadlinePotentialWinner = new Date(
    new Date(deadline).getTime() - TWO_DAY_INTERVAL
  );

  const [giftModalVisible, setGiftModalVisible] = useState(false);

  const handleGiftModal = () => {
    setGiftModalVisible((prevModalVisible) => !prevModalVisible);
  };

  return (
    <>
      <div className="page-block">
        <Row gutter={[25, 0]}>
          <Col xs={24}>
            {isMobile &&
              !isUpcoming &&
              !isHistory &&
              !isHistoryOverview &&
              !isResultOverview &&
              !isWinner &&
              !isNoOneWinner && <ProductCountdown product={product} />}
            {isMobile && (
              <>
                <Title level={2} className="page-block-product-title">
                  {product?.product_name}
                </Title>
                {isBidPage ? (
                  <div className="page-block-product-code">
                    Código: {product?.product_code}
                  </div>
                ) : null}
              </>
            )}
            <div
              className={`page-block-image ${
                isHistory || isHistoryOverview ? "history-product" : ""
              }`}>
              {productImage ? (
                <Carousel autoplay>
                  {productImage?.map((image) => {
                    return (
                      <img
                        src={image}
                        alt="Product images"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = ProductDefaultImage;
                        }}
                      />
                    );
                  })}
                </Carousel>
              ) : (
                <img src={ProductDefaultImage} alt="Default product images" />
              )}
              <Paragraph className="image-subtext">
                Imágenes referenciales
              </Paragraph>
              {/* <Button
                className="page-block-image-share"
                icon={<ShareIcon style={{ fontSize: "20px" }} />}
              /> */}
            </div>
            <div
              className={`page-block-product ${
                isHistory || isHistoryOverview ? "history-product" : ""
              }`}>
              {!isMobile &&
                !isUpcoming &&
                !isHistory &&
                !isHistoryOverview &&
                !isResultOverview &&
                !isWinner &&
                !isNoOneWinner && <ProductCountdown product={product} />}
              {!isMobile && (
                <>
                  <Title level={2} className="page-block-product-title">
                    {product?.product_name}
                  </Title>
                  {isBidPage ? (
                    <div className="page-block-product-code">
                      Código: {product?.product_code}
                    </div>
                  ) : null}
                </>
              )}

              {!isResultOverview && !isHistoryOverview && product?.gift_name ? (
                <Row className="gift-container" justify="start">
                  <div className="gift-bonus">
                    <GiftIcon />
                    <span>{t("product.gift_bonus")}</span>
                  </div>
                  <div className="gift-detail">
                    <img
                      src={product?.gift_image || ProductDefaultImage}
                      alt="Gift"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = ProductDefaultImage;
                      }}
                    />
                    <div className="gift-detail-desc">
                      <span>{product?.gift_name}</span>
                      <button onClick={() => setGiftModalVisible(true)}>
                        {t("product.gift_more_details")}
                      </button>
                    </div>
                  </div>
                </Row>
              ) : null}

              {/* History (Finished) */}
              {(isHistory || isHistoryOverview) && (
                <>
                  <FinishedBid product={product} />
                  <CurrentBid product={product} />
                </>
              )}

              {/* Upcomming */}
              {isUpcoming && (
                <>
                  <UpcomingBid product={product} />
                  <CurrentBid product={product} />
                  <PlaceBid isDisabled={true} />
                </>
              )}

              {/* Bidding */}
              {!isUpcoming &&
                !isHistory &&
                !isHistoryOverview &&
                !isResultOverview &&
                !isWinner &&
                !isNoOneWinner && (
                  <>
                    <CurrentBid product={product} />
                    {showForm ? (
                      <PlaceBidForm product={product} />
                    ) : (
                      <PlaceBid />
                    )}
                  </>
                )}

              {(isWinner || isNoOneWinner) && (
                <>
                  <FinishedBid product={product} />
                  <CurrentBid
                    product={product}
                    isResultOverview={isResultOverview}
                    isWinner={isWinner}
                    isNoOneWinner={isNoOneWinner}
                  />
                </>
              )}
              {(isResultOverview || isHistoryOverview) && (
                <Row>
                  <Col span={24}>
                    <Link
                      to={(isHistoryOverview
                        ? PATHS.HISTORY_DETAIL_PAGE
                        : PATHS.RESULTS_DETAIL_PAGE
                      ).replace(":cp_id", product.cp_id)}
                      className="page-block-view-detail">
                      {t("product.view_detail")}
                    </Link>
                  </Col>
                  {isWinner && isLogin && (
                    <Col span={24}>
                      <Button
                        className="page-block-view-detail"
                        onClick={handleClickViewWinner}
                        loading={isLoading}>
                        {t("product.winter_info")}
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </div>
          </Col>
        </Row>
        <BitelModal error={error} data={data} />
        <GiftModal
          visible={giftModalVisible}
          handleClose={handleGiftModal}
          product={product}
        />
      </div>
      {currentDate > deadlinePotentialWinner &&
      isPotentialWinner &&
      deadline ? (
        <PotentialWinner product={product} />
      ) : null}
    </>
  );
};

export default ProductDetail;
